import { types } from '../actions/types';

export const ServiceReducer = (
  state = {
    get: null,
    create: null,
    update: null,
    deleteById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.svcGetServices:
      return { ...state, get: action.payload };
    case types.svcCreateService:
      return { ...state, create: action.payload };
    case types.svcUpdateService:
      return { ...state, update: action.payload };
    case types.svcDeleteServiceById:
      return { ...state, deleteById: action.payload };
    default:
      return state;
  }
};
